import React from 'react';
import { Modal } from 'antd';
import { RxCross2 } from 'react-icons/rx';
import { LoaderCircle } from 'lucide-react';

const EmailSendsPopup = ({ isOpen, onClose, onConfirm, loading = false }) => {
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      centered
      className="custom-dark-confirm-modal"
    >
      <div className="relative p-4">
        <button
          onClick={onClose}
          className="absolute right-0 top-0 w-5 h-5 text-[#8D8D8D] hover:text-white"
        >
          <RxCross2 size={18} />
        </button>

        <h2 className="text-center text-lg font-semibold text-white font-public-sans leading-[22px]">
          Confirm Email Send
        </h2>

        <div className="mt-[12px] flex flex-col items-center">
          <p className="text-[15px] font-normal text-[#969696] leading-[22px] text-center font-public-sans">
            Are you sure you want to send this email?
          </p>
          <p className="text-[15px] font-normal text-[#969696] leading-[22px] text-center font-public-sans mt-1">
            This action cannot be undone.
          </p>
        </div>

        <div className="flex justify-center gap-4 mt-[24px]">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex items-center justify-center px-[15px] py-[2px] border border-[#878787] rounded-[15px] w-20 h-7 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="text-[#878787] text-xs font-normal font-inter">
              Cancel
            </span>
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex items-center justify-center px-3 py-[2px] border border-[#1A7DD1] rounded-[15px] w-24 h-7 gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <LoaderCircle className="w-4 h-4 text-[#1A7DD1] animate-spin" />
            ) : (
              <span className="text-[#1A7DD1] text-lg font-normal">✓</span>
            )}
            <span className="text-[#1A7DD1] text-xs font-normal font-inter">
              {loading ? 'Sending...' : 'Send'}
            </span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EmailSendsPopup;